import Text from '@/components/ui/custom/dataDisplay/Text';
import InfinityList from '@/components/ui/custom/InfinityList';
import { TempLessonBlock } from '@/models/_deprecated/LessonBlock';
import LoadingView from '@/pages/courses/LoadingView';
import DraggableLesson from '../DraggableLesson';
import LessonReplacer from '../LessonReplacer';
import { BaseListProps } from './ListLessonsFactory';

interface ListLessonBlocksProps extends BaseListProps {
  lessonBlocksWithLessons: TempLessonBlock[];
}

export function ListLessonBlocks({
  course,
  deleteLesson,
  lessonBlocksWithLessons = [],
  invalidateBlock,
  isLoadingLessonList,
  hasNextPage,
  isFetchingNextPage,
  onReachEnd,
}: ListLessonBlocksProps) {
  if (isLoadingLessonList) return <LoadingView />;

  return (
    <InfinityList
      isFetchingNextPage={isFetchingNextPage}
      onReachEnd={onReachEnd}
      hasNextPage={hasNextPage}
      className="gap-4"
    >
      {lessonBlocksWithLessons.map(lessonBlock => (
        <div key={lessonBlock.id} className="flex flex-col gap-4">
          <Text text={lessonBlock.name} format="rubik-500" />
          <LessonReplacer isDropDisabled>
            {lessonBlock.lessons.map((lesson, index) => (
              <DraggableLesson
                key={lesson.id}
                lesson={lesson}
                course={course}
                block={lessonBlock}
                deleteLesson={deleteLesson}
                updateLessons={async () => {
                  await invalidateBlock?.(lessonBlock.id);
                }}
                index={index}
                isDropDisabled
              />
            ))}
          </LessonReplacer>
        </div>
      ))}
    </InfinityList>
  );
}
